import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../../typography'
import Image from '../../image'

import { useBreakpoint } from '../../../../hooks/breakpoint'

const Benefits = ({ benefits, ...attrs }) => {
  const breakpoint = useBreakpoint()

  attrs.className = classNames(
    attrs.className,
    [
      'relative',
      'pt-10',
      'pb-10',
      'md:bg-white'
    ]
  )

  return <section {...attrs}>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <div
        className={
          classNames([
            'flex',
            'flex-row',
            'flex-wrap',
            'justify-center',
            '-mx-4'
          ])
        }>
        {
          benefits.map(({ value, id }) => {
            const { icon, text, title } = value || {}
            const { title: iconTitle, meta } = icon
            return (<div
              key={id}
              className={
                classNames([
                  'relative',
                  'p-4',
                  'flex',
                  'flex-col',
                  'justify-center'
                ])
              }
              style={{
                flexBasis: breakpoint.lgAndUp ? '33.333333%' : (breakpoint.mdAndUp ? '50%' : '100%')
              }}>
              <div
                className='flex items-center' >
                <Image
                  style={{
                    width: 22,
                    height: 22,
                    marginRight: 12
                  }}
                  alt={iconTitle}
                  src={meta.downloadUrl} />
                <Typography size='four' className='text-gray-500' weight='bold' >{title}</Typography>
              </div>
              <Typography size='three' className='text-gray-400'>{text}</Typography>
            </div>
            )
          })
        }
      </div>
      <hr className='w-full border-gray-400' />
    </div>
  </section >
}

Benefits.propTypes = {
  benefits: PropTypes.array
}

export default Benefits
